import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=6908adce&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"
import style0 from "./MainPage.vue?vue&type=style&index=0&id=6908adce&prod&scoped=true&lang=css"
import style1 from "./MainPage.vue?vue&type=style&index=1&id=6908adce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908adce",
  null
  
)

export default component.exports